<div class="panel panel-success" style="height: 95%">
  <div class="panel-heading">
    <h5 style="display: inline-block">
      <span>Presets</span>
    </h5>
    <div class="btn-toolbar pull-right">
      <div class="btn-group btn-group-md">
        <button
          type="button"
          class="btn btn-primary"
          title="Add Preset"
          (click)="showModal()"
        >
          <i data-toggle="tooltip" class="fa fa-plus-square fa-lg"></i>
        </button>
      </div>
      <div class="btn-group btn-group-md">
        <preset-filter></preset-filter>
      </div>
    </div>
  </div>
  <div
    class="panel-body panel-list"
    style="
      height: 95%;
      overflow-y: hidden;
      padding-bottom: 0px;
      padding-top: 0px;
    "
  >
    <div *ngIf="processing" class="list-group">
      <i class="fa fa-spinner fa-spin"></i> Loading Presets...
    </div>
    <div class="panel-group" style="height: 95%; overflow-y: auto">
      <preset-entity
        [preset]="preset"
        [documentsVisible]="preset.documentsVisible"
        *ngFor="let preset of presets.Data"
      ></preset-entity>
    </div>
  </div>
</div>

<div
  bsModal
  #AddPreset="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ keyboard: false, backdrop: 'static' }"
>
  <div class="modal-dialog" style="width: 1000px">
    <form (ngSubmit)="createPreset()">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal()">
            &times;
          </button>
          <h4 class="modal-title" id="myModalLabel">Create Preset</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">&nbsp;</div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="input-group">
                <div class="input-group-addon">
                  <label>Preset Name :</label>
                </div>
                <input
                  name="presetName"
                  id="presetId"
                  type="text"
                  class="form-control"
                  placeholder="Preset Name"
                  [(ngModel)]="NewPreset"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">&nbsp;</div>
          </div>

          <div class="modal-footer">
            <div class="row">
              <div class="col-md-3">
                <button
                  type="button"
                  class="btn btn-default"
                  (click)="createPresetAndAddAnother()"
                >
                  Create and Add Another
                </button>
              </div>
              <div class="col-md-7"></div>
              <div class="col-md-1">
                <button
                  type="button"
                  class="btn btn-close"
                  (click)="closeModal()"
                >
                  Close
                </button>
              </div>
              <div class="col-md-1">
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="createPreset()"
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
